var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-chart__button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"plus-icon__block"},[_c('SvgIcon',{attrs:{"name":"add-chart-plus","height":"40","width":"40"}})],1),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }